import React from "react";
import "../css/global.css"; // Ensure this path is correct
import "../css/index.css";  // Ensure this path is correct

const HomeAboutUs = () => {
  return (
    <section id="about_h" className="p-3 pt-5 mt-4">
      <div className="container-xl">
        <div className="row about_h1 text-center mb-4">
          <div className="col-md-12">
            <h4 className="col_blue">About Us</h4>
            <h1 className="mt-3">4000+ Buyers Across The World</h1>
          </div>
        </div>
        <div className="row about_h2 mx-auto">
          <div className="col-md-4">
            <div className="about_h2i text-center">
              <h2>739 +</h2>
              <h5 className="fw-normal mb-0">Happy Customer</h5>
            </div>
          </div>
          <div className="col-md-4">
            <div className="about_h2i text-center">
              <h2>30 +</h2>
              <h5 className="fw-normal mb-0">Exports</h5>
            </div>
          </div>
          <div className="col-md-4">
            <div className="about_h2i text-center">
              <h2>888 +</h2>
              <h5 className="fw-normal mb-0">Our Product</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutUs;
